import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client.js';
import type { Supplier } from './types.js';

/**
 * Annuaire-flavoured suppliers fetch: loads up to 50 entries for the
 * tenant without requiring a query string (the outbound-wizard
 * `useSearchSuppliers` only fires when q ≥ 2). Caller is expected to
 * apply name/SIREN client-side filtering for snappy UX over the
 * already-loaded list.
 */
export function useSuppliers(tenantId: string) {
  return useQuery<Supplier[]>({
    queryKey: ['annuaire-suppliers', tenantId],
    queryFn: () =>
      apiFetch<Supplier[]>(`/tenants/${encodeURIComponent(tenantId)}/suppliers?limit=50`),
    enabled: Boolean(tenantId),
    staleTime: 60_000,
  });
}
